// src/features/policies/modals/CreatePolicyModal.jsx

import React, { useState } from "react";

import PolicyForm from "../components/PolicyForm";

import { createPolicy } from "../api/policyApi";

import { emptyPolicy } from "../types/policy";

export default function CreatePolicyModal({

  apiKey,

  tenantId,

  onClose,

  onSaved

}) {

  const [policy, setPolicy] = useState(
    emptyPolicy()
  );

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  async function handleSave() {

    if (!policy.policyName.trim()) {

      setError("Policy name is required");

      return;
    }

    setLoading(true);

    setError("");

    try {

      await createPolicy(
        apiKey,
        tenantId,
        policy
      );

      onSaved();

      onClose();

    } catch (e) {

      setError(e.message);

    } finally {

      setLoading(false);

    }
  }

  const POLICY_TEMPLATES = {
    payment_processor: {
      policyName: 'payment_processing_admin_policy',
      policyDescription: 'Grants authorized payment microservices and managers full detokenization rights for cardholder data.',
      priority: 100,
      effect: 'ALLOW',
      actions: ['TOKENIZE', 'DETOKENIZE'],
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN'],
      resourceScope: {
        schemas: ['*'],
        fields: ['card_pan', 'cvv', 'cardholder_name']
      },
      conditions: []
    },
    support_masked: {
      policyName: 'customer_support_masked_policy',
      policyDescription: 'Restricts Tier 1 and 2 customer support agents to partial card masks (**** 1234) and redacts CVV.',
      priority: 50,
      effect: 'ALLOW',
      actions: ['DETOKENIZE'],
      roles: ['ROLE_USER'],
      resourceScope: {
        schemas: ['*'],
        fields: ['card_last4', 'email', 'phone']
      },
      conditions: []
    },
    genai_privacy: {
      policyName: 'genai_llm_privacy_policy',
      policyDescription: 'Mandates real-time PII/PHI quarantine tokenization for all prompts passed to external AI models.',
      priority: 90,
      effect: 'ALLOW',
      actions: ['TOKENIZE'],
      roles: ['ROLE_USER', 'ROLE_MANAGER', 'ROLE_ADMIN'],
      resourceScope: {
        schemas: ['*'],
        fields: ['*']
      },
      conditions: []
    }
  };

  const loadTemplate = (key) => {
    const tmpl = POLICY_TEMPLATES[key];
    if (tmpl) {
      setPolicy({
        ...emptyPolicy(),
        ...tmpl
      });
      setError('');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-lg">
        <div className="modal-title">
          Create Access &amp; Detokenization Policy
        </div>

        <div className="modal-subtitle">
          Define Zero-Trust access rules, permitted actions (tokenize/detokenize), assigned roles, and data scopes.
        </div>

        {error && (
          <div className="policy-error">
            {error}
          </div>
        )}

        {/* 1-Click Sample Policy Templates */}
        <div className="policy-template-picker" style={{
          background: 'rgba(16, 28, 51, 0.6)',
          border: '1px solid rgba(16, 185, 129, 0.3)',
          borderRadius: '10px',
          padding: '12px 16px',
          marginBottom: '20px'
        }}>
          <span style={{
            fontSize: '0.75rem',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: '#10b981',
            display: 'block',
            marginBottom: '8px'
          }}>
            ⚡ Load Pre-configured Sample Policy:
          </span>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <button
              type="button"
              className="btn btn-secondary"
              style={{ fontSize: '0.8rem', padding: '5px 12px' }}
              onClick={() => loadTemplate('payment_processor')}
            >
              💳 Payment Processor (Full Detokenize)
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              style={{ fontSize: '0.8rem', padding: '5px 12px' }}
              onClick={() => loadTemplate('support_masked')}
            >
              🎧 Support Agent (Masked View Only)
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              style={{ fontSize: '0.8rem', padding: '5px 12px' }}
              onClick={() => loadTemplate('genai_privacy')}
            >
              🤖 GenAI LLM Privacy Firewall
            </button>
          </div>
        </div>

        <PolicyForm
          policy={policy}
          onChange={setPolicy}
        />

        <div className="modal-actions">

          <button
            className="btn btn-primary"
            disabled={loading}
            onClick={handleSave}
          >

            {loading
              ? "Creating..."
              : "Create Policy"}

          </button>

          <button
            className="btn btn-secondary"
            onClick={onClose}
          >

            Cancel

          </button>

        </div>

      </div>

    </div>
  );
}